import { Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AddByEmail, AddByEmailConfig, AddByEmailResult } from 'components/forms/AddByEmail';
import { Color } from 'core';
import { API_DATA_SUCCESS } from 'middleware/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { handleCreateCourseUser } from 'store/course-user';
import { handleGetLearnerStats } from 'store/learner-stats';

interface Props {
  courseId: string;
  partnerId: string | null;
  isPublished: boolean;
  close: () => void;
}

export const AddLearnersByEmail = React.memo<Props>(({ courseId, isPublished, close }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [shouldSendEmail, setShouldSendEmail] = React.useState(isPublished);

  const config: AddByEmailConfig = {
    title: t('Manage Learners by Email'),
    headerText: t('Add learners'),
    confirmText: t('Add Learners'),
    successText: count => t('Add Learners By Email Success Text', { count }),
    failureText: count => t('Add Learners By Email Failure Text', { count }),
  };

  const handleInvite = async (emails: string[]): Promise<AddByEmailResult[]> => {
    const promises = emails.map(email =>
      dispatch(handleCreateCourseUser(courseId, email, shouldSendEmail, 'enrolled_via_direct_invite', false))
    );
    const results = await Promise.all(promises);

    return results.map((result, i) => ({
      email: emails[i],
      success: (result as any).type === API_DATA_SUCCESS,
    }));
  };

  const handleSuccess = () => {
    dispatch(handleGetLearnerStats(courseId));
  };

  const emailCheckbox = isPublished ? (
    <FormControlLabel
      control={
        <Checkbox
          checked={shouldSendEmail}
          onChange={() => setShouldSendEmail(!shouldSendEmail)}
          style={{ padding: '12px', color: Color.primaryBlue, fontSize: '0.8rem' }}
          data-type="checkbox"
        />
      }
      label={<Typography style={{ fontSize: 18 }}>{t('Send email invites')}</Typography>}
    />
  ) : null;

  return (
    <AddByEmail
      config={config}
      onClose={close}
      onInvite={handleInvite}
      onSuccess={handleSuccess}
      additionalControls={emailCheckbox}
    />
  );
});
